module.exports = __webpack_public_path__ + "media/images/pc/static/consulting-service-flow-d36c4650f59fece6e7ec4eb04e751978.png";